import { useAppSelector } from '../store-hooks';
import { metaSelectors } from './metaSlice';

// HOOK-BASED SELECTORS ========================================================
export const metaSliceSelectors = {
  useSelectFeedbackDescriptions: () =>
    useAppSelector(metaSelectors.selectFeedbackDescriptions),

  useSelectNeedsMetadata: () =>
    useAppSelector(metaSelectors.selectNeedsMetadata),
  useSelectNeedIssueOptions: () =>
    useAppSelector(metaSelectors.selectNeedIssueOptions),

  useSelectResourceResearchActivity: () =>
    useAppSelector(metaSelectors.selectResourceResearchActivity),
  useSelectToastConfig: () => useAppSelector(metaSelectors.selectToastConfig),
  useSelectRaceEthnicityOptions: () =>
    useAppSelector(metaSelectors.selectRaceEthnicityOptions),
  // Call Outcomes -------------------------------------------------------------
  useSelectCallOutcomes: () => useAppSelector(metaSelectors.selectCallOutcomes),
  useSelectCallOutcomeOptions: (
    targetOutcomeType: 'resourcing' | 'interaction',
    includeEngagedStatus: boolean,
    callCreatedAt?: number
  ) =>
    useAppSelector(state =>
      metaSelectors.selectCallOutcomeOptions(state, {
        includeEngagedStatus,
        targetOutcomeType,
        callCreatedAt,
      })
    ),
  useSelectCallOutcomeById: (id: number) =>
    useAppSelector(metaSelectors.selectCallOutcomeById(id)),
  // Visit Outcomes ------------------------------------------------------------
  useSelectVisitOutcomes: () =>
    useAppSelector(metaSelectors.selectVisitOutcomes),
  useSelectVisitOutcomeOptions: (
    targetOutcomeType: 'resourcing' | 'interaction',
    visitCreatedAt?: number
  ) =>
    useAppSelector(state =>
      metaSelectors.selectVisitOutcomeOptions(state, {
        targetOutcomeType,
        visitCreatedAt,
      })
    ),
  useSelectVisitOutcomeById: (id: number) =>
    useAppSelector(metaSelectors.selectVisitOutcomeById(id)),
};
